import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Box, Flex } from 'rebass';

import Loading from '../../Components/Loading';
import { SPACE } from '../../Components/Theme';

const defaultChildrenFn = data => <div>{JSON.stringify(data)}</div>;
const defaultLoadingFn = loadingOverlay => (
  <Box pt={SPACE.medium}>
    <Loading
      dimmer={loadingOverlay}
      loaderProps={!loadingOverlay ? { active: true, inline: 'centered' } : {}}
    />
  </Box>
);
const defaultErrorFn = error => <div>{JSON.stringify(error)}</div>;

export class QueryComponent extends Component {
  componentDidCatch(error, info) {
    console.log(error, info);
    return null;
  }
  render() {
    const {
      query,
      renderLoading,
      renderError,
      variables,
      skip,
      delay,
      children,
      loadingOverlay,
      fetchPolicy,
    } = this.props;
    return (
      <Query
        query={query}
        variables={variables}
        skip={skip}
        delay={delay}
        fetchPolicy={fetchPolicy}
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return renderLoading(loadingOverlay);
          if (error) return renderError(error);
          return children(data, refetch);
        }}
      </Query>
    );
  }
}

QueryComponent.propTypes = {
  query: PropTypes.object.isRequired,
  children: PropTypes.func,
  renderLoading: PropTypes.func,
  renderError: PropTypes.func,
  variables: PropTypes.object,
  skip: PropTypes.bool,
  delay: PropTypes.bool,
  loadingOverlay: PropTypes.bool,
};

QueryComponent.defaultProps = {
  children: defaultChildrenFn,
  renderLoading: defaultLoadingFn,
  renderError: defaultErrorFn,
  loadingOverlay: false,
};

export default QueryComponent;
